import { FC } from "react";
import { ClockCircleOutlined } from "@payping/icons";
import { Collapse, Timeline } from "@payping/web-components";
import { timelineApis } from "@payping/api";
import { toJalali } from "@payping/utils/dateUtils";
import { useAsyncRetry } from "react-use";

interface Props {
  code: string;
}

const DetailTimeline: FC<Props> = (props) => {
  const { code } = props;

  const { value: timeline } = useAsyncRetry(() => timelineApis.v1TimeLineListGet(0, code), []);

  return (
    <Collapse>
      <Collapse.Panel key={0} header={"مسیر پیمایش"}>
        <Timeline>
          {timeline?.map((item) => (
            <Timeline.Item key={item.code}>
              <div className="tw-pr-3">
                <p className={"color--gray500"}>
                  {toJalali({ date: item.eventDate, toFormat: "HH:mm jYYYY/jMM/jDD" }).string}
                  <ClockCircleOutlined
                    width={12}
                    className={"color--gray500 tw-mr-[5px] tw-mt-1"}
                  />
                </p>
                <p className="tw--mt-3" style={{ color: "#202124" }}>{item.title}</p>
                {item.description && item.description.replace(/ /g, "").length > 0 && (
                  <div
                    className="tw-mb-4 tw-w-full tw-rounded-lg tw-p-4"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <span style={{ color: "#666666" }}>{item.description}</span>
                  </div>
                )}
              </div>
            </Timeline.Item>
          ))}
        </Timeline>
      </Collapse.Panel>
    </Collapse>
  );
};

export default DetailTimeline;
